import React, { useState, useEffect } from 'react'
import { EmptyContent } from './includes/EmptyContent';
import { SideMenu } from './includes/SideMenu';
import { QuestionInputStep } from './includes/QuestionInputStep'
import { Settings } from './includes/Settings';
import { ProductsTable } from './includes/ProductsTable';
import { SelectProducts } from './includes/SelectProducts';
import s from './CreateQuiz.module.scss'
import quizUtils from './utils';

export const QuizForm = ({ setShowCreateQuiz, quizToEdit,
    setQuizToEdit, fetch }) => {
    const [segmentItemCounters, setSegmentItemCounters] = React.useState({
        1: false,
        2: false,
        3: false,
        showErrorText: false,
    });
    const [quiz, setQuiz] = useState(quizToEdit || {
        image: `https://static.squadded.co/assets/group/${Math.floor(
            Math.random() * 10,
        )}.png`,
        title: '',
        showPriceQuestion: true,
        priceHeaderInput: 'Choose your price range',
        couponCode: '',
        type: 'quiz',
        body: '',
        questions: [
            {
                title: '',
                answers: [
                    {
                        title: "",
                        image: ""
                    }, {
                        title: "",
                        image: ""
                    }, {
                        title: "",
                        image: ""
                    }
                ]
            },
            {
                title: '',
                answers: [
                    {
                        title: "",
                        image: ""
                    }, {
                        title: "",
                        image: ""
                    }, {
                        title: "",
                        image: ""
                    }
                ]
            }
        ],
        itemsChoices: [
            [
                [/*[0, 0]*/], [/*[0, 1]*/], [/*[0, 2]*/],
            ],
            [
                [/*[1, 0]*/], [/*[1, 1]*/], [/*[1, 2]*/],
            ],
            [
                [/*[2, 0]*/], [/*[2, 1]*/], [/*[2, 2]*/],
            ],
        ],
        price: [
            {
                title: '',
                from: 0,
                to: 0,
            },
            {
                title: '',
                from: 0,
                to: 0,
            },
            {
                title: '',
                from: 0,
                to: 999999,
            },
        ],
    })
    const [questionNumber, setQuestionNumber] = useState(1);
    const [highestQuestionNumber, setHighestQuestionNumber] = useState(quizToEdit ? 4 : 1);
    const [goToTableButton, setGoToTableButton] = useState(false);
    const [goToPriceButton, setGoToPriceButton] = useState(false);
    const [goToSettingsButton] = useState(true);
    const [currentTableAnswer, setCurrentTableAnswer] = useState('')
    const [highestPrice, setHighestPrice] = useState(0)
    useEffect(() => {
        if (questionNumber === 1) {
            filledQuestionsAndChoices()
            if (quizToEdit) {
                canShowPriceButton()
            }
        } else if (questionNumber === 2) {
            canShowPriceButton()
        }
        if (questionNumber > highestQuestionNumber) {
            setHighestQuestionNumber(questionNumber)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionNumber])

    function canShowPriceButton() {
        const {
            allCellsHaveItems,
            currHighestPrice
        } = quizUtils.canShowPriceButton(quiz)
        setHighestPrice(currHighestPrice)
        setGoToPriceButton(allCellsHaveItems)
    }

    function addItemToChoice(item) {
        quizUtils.addItemToChoice({ quiz, item, currentTableAnswer })
        setQuiz({
            ...quiz,
        })
        canShowPriceButton()
    }
    function removeItem(e) {
        const tableAnswerToSelect = quizUtils.removeItem(quiz, e)
        setCurrentTableAnswer(tableAnswerToSelect)
        setQuiz({
            ...quiz,
        })
        canShowPriceButton()
    }

    function calculateSegments(sliderValues) {
        const lowerPrice = sliderValues[0];
        const higherPrice = sliderValues[1];

        quiz.price[0].to = lowerPrice

        quiz.price[1].from = lowerPrice
        quiz.price[1].to = higherPrice

        quiz.price[2].from = higherPrice
        const segmantErrors = quizUtils.calculateSegments(sliderValues, quiz.itemsChoices)
        setSegmentItemCounters({ ...segmantErrors })
    }

    function goToTable() {
        setQuestionNumber(3);
    }
    function goToStep(e) {
        const value = e.target.attributes.data?.value || e.target.parentElement.attributes.data?.value
        setQuestionNumber(JSON.parse(value));
    }

    const filledQuestionsAndChoices = () => {
        setGoToTableButton(quizUtils.filledQuestionsAndChoices(quiz))
    }

    const setChoiceTitles = (questionIndex, choiceIndex, titleToSet) => {
        const newQuiz = { ...quiz }
        newQuiz.questions[questionIndex].answers[choiceIndex].title = titleToSet
        setQuiz(newQuiz)
        filledQuestionsAndChoices()
    }

    function updateChoiceImage({ imageUrl, questionIndex, choiceIndex }) {
        quiz.questions[questionIndex].answers[choiceIndex].image = getImageUrlWithoutPrefix(imageUrl);
        setQuiz({
            ...quiz,
        })
    }

    function updateBackgroundImage(url) {
        quiz.image = getImageUrlWithoutPrefix(url);
        setQuiz({
            ...quiz,
        })
    }

    const setQuestionTitle = (title, index) => {
        quiz.questions[index].title = title;
        setQuiz({
            ...quiz,
            questions: quiz.questions,
        })
        filledQuestionsAndChoices()
    }
    const setQuizTitle = (titleInput) => {
        quiz.title = titleInput?.target?.value;
        setQuiz({
            ...quiz,
        })
    }
    const setQuizButtonText = (buttonText) => {
        quiz.button = buttonText?.target?.value;
        setQuiz({
            ...quiz,
        })
    }
    const setCouponCode = (couponCodeInput) => {
        quiz.couponCode = couponCodeInput?.target?.value;
        setQuiz({
            ...quiz,
        })
    }
    const setQuizDescription = (descriptionInput) => {
        quiz.body = descriptionInput?.target?.value;
        setQuiz({
            ...quiz,
        })
    }
    function setCurrQuestion(params) {
        setQuestionNumber(JSON.parse(params) + 1)
    }
    const addChoiceToQuestion = (index) => {
        quizUtils.addChoiceToQuestion(index, quiz)
        setQuiz({
            ...quiz,
            questions: quiz.questions,
        })
        filledQuestionsAndChoices()
    }
    function removeChoice(choiceIdx, questionIdx) {
        const arrayToHanle = quiz.questions[questionIdx].answers;
        const newQuiz = { ...quiz }
        arrayToHanle.splice(choiceIdx, 1);
        if (questionIdx === 0) {
            quiz.itemsChoices.splice(choiceIdx, 1);
        } else {
            quiz.itemsChoices.forEach((choicesArray) => {
                choicesArray.splice(choiceIdx, 1);
            })
        }
        quiz.questions[questionIdx].answers = arrayToHanle;
        setQuiz(newQuiz)
        filledQuestionsAndChoices()
    }
    function nextButtonClicked() {
        setQuestionNumber(questionNumber + 1)
    }
    function previousButtonClicked() {
        setQuestionNumber(questionNumber - 1)
    }
    function goToMainQuizPage(save) {
        if (!save) {
            setQuizToEdit(null)
        }
        setQuestionNumber(0);
        setShowCreateQuiz(false)
    }

    function priceHeaderInput(e) {
        quiz.priceHeaderInput = e.target.value;
        setQuiz({
            ...quiz,
        })
    }

    function togglePriceQuestion(e) {
        quiz.showPriceQuestion = e.target.checked;
        setQuiz({
            ...quiz,
        })
    }

    function updateButtonSegmentTexts(e) {
        quiz.price[e.target.name].title = e.target.value || e.target.dataset.default;
        setQuiz({
            ...quiz,
        })
    }
    return (
        <>
            <SideMenu goToMainQuizPage={goToMainQuizPage} goToStep={goToStep} highestQuestionNumber={highestQuestionNumber} setQuizTitle={setQuizTitle} goToTable={goToTable} setCurrQuestion={setCurrQuestion} quiz={quiz} questionNumber={questionNumber} />
            {questionNumber === 1 ?
                <React.Fragment key={questionNumber}>
                    <div className={`${s.sideMenu} ${s.positioning}`} style={{ width: '468px' }}>
                        <QuestionInputStep
                            updateChoiceImage={updateChoiceImage}
                            goToTableButton={goToTableButton}
                            removeChoice={removeChoice}
                            setChoiceTitles={setChoiceTitles}
                            addChoiceToQuestion={addChoiceToQuestion}
                            setQuestionTitle={setQuestionTitle}
                            quiz={quiz}
                            questionNumber={questionNumber}
                            nextButtonClicked={nextButtonClicked}
                        />
                        <button onClick={nextButtonClicked} disabled={!goToTableButton} style={{ borderRadius: '8px', float: 'right' }} type="button" className="btn btn-dark font-size-h6 my-3">
                            Next
                        </button>
                    </div >
                </React.Fragment>
                :
                questionNumber === 3 || questionNumber === 2 ?
                    <>
                        <ProductsTable priceHeaderInput={priceHeaderInput} togglePriceQuestion={togglePriceQuestion} segmentItemCounters={segmentItemCounters} calculateSegments={calculateSegments} updateButtonSegmentTexts={updateButtonSegmentTexts} highestPrice={highestPrice} showPriceInput={questionNumber === 3} removeItem={removeItem} currentTableAnswer={currentTableAnswer} setCurrentTableAnswer={setCurrentTableAnswer} quiz={quiz}>
                            <div style={{ marginTop: '40px' }}>
                                <button onClick={previousButtonClicked} type="button" className="btn btn-outline-dark">Back</button>
                                <div style={{ float: 'right' }}>
                                    <button onClick={nextButtonClicked} disabled={questionNumber === 2 ? !goToPriceButton : !goToSettingsButton} style={{ borderRadius: '8px' }} type="button" className="btn btn-dark font-size-h6">
                                        Next
                                    </button>
                                    {questionNumber === 2 && !goToPriceButton ?
                                        <div style={{
                                            marginTop: '10px',
                                            color: 'red'
                                        }}>There should be at least 2 products for each cell</div>
                                        : null}
                                </div>
                            </div>
                        </ProductsTable>
                        {questionNumber === 2 ?
                            <SelectProducts removeItem={removeItem} quiz={quiz} addItemToChoice={addItemToChoice} currentTableAnswer={currentTableAnswer} />
                            : null
                        }
                    </>
                    :
                    questionNumber === 4 ?
                        <Settings fetch={fetch} setQuizButtonText={setQuizButtonText} setCouponCode={setCouponCode} highestPrice={highestPrice} updateBackgroundImage={updateBackgroundImage} goToMainQuizPage={goToMainQuizPage} quiz={quiz} setQuizTitle={setQuizTitle} setQuizDescription={setQuizDescription}>
                            <button onClick={previousButtonClicked} type="button" className="btn btn-outline-dark my-3">Back</button>
                        </Settings>
                        :
                        <EmptyContent />
            }
        </>
    )
}
function getImageUrlWithoutPrefix(imageUrl) {
    if (!imageUrl) {
        return '';
    }
    const splittedUrl = imageUrl.split("/userdata");
    const urlWithoutPrefix = `/userdata${splittedUrl[1]}`;
    return urlWithoutPrefix;
}

